import { BID_REQUEST_STATUS_ENUM, RISK_STATUS_ENUM } from "interfaces";
import { IStores } from "stores";
import { CURRENCY_TYPE, isStatusIncluded } from "utils";

export function checkBidProcess(type: "IMP" | "EXP", status: string) {
  if (type === "IMP") return true;
  if (type === "EXP") {
    return !isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.DRAFT,
      BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
      BID_REQUEST_STATUS_ENUM.NEW,
      BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
    ]);
  }
}

type DefaultActiveKey = "documents" | "quotes" | "bankStatements" | "transactions" | "walletCheck";
type Stores = Pick<IStores, "bidCard" | "user" | "bidTransactions" | "bidWalletChecks">;

export const getDefaultActiveTab = ({
  stores,
  showQuotes,
}: {
  stores: Stores;
  showQuotes?: boolean;
}): DefaultActiveKey => {
  const { bidCard, user, bidTransactions, bidWalletChecks } = stores;
  const { isProvider, isOperator, isCustomer, isRiskManager, isLPRiskManager } = user.roles;
  const isProviderOrLPRiskManager = isProvider || isLPRiskManager;

  const status = bidCard.bid.status;
  const isImport = bidCard.bid.contract.direction === "IMP";
  const isExport = bidCard.bid.contract.direction === "EXP";

  const transactionsApproveNeeded = bidTransactions.allData.some(
    (i) => i.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED && i.currency !== "NATIVE"
  );
  const walletChecksApproveNeeded = bidWalletChecks.allData.some(
    (i) => i.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED
  );

  if (isRiskManager && transactionsApproveNeeded) {
    return "transactions";
  } else if (isRiskManager && walletChecksApproveNeeded) {
    return "walletCheck";
  }

  if (
    isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.DRAFT,
      BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
    ]) &&
    (isCustomer || isOperator)
  ) {
    return "documents";
  }

  if (isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.NEW])) {
    return "quotes";
  }

  if (isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED])) {
    return "quotes";
  }

  if (isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.FUNDING])) {
    if (isCustomer) {
      return isImport ? "bankStatements" : "transactions";
    }

    if (isProviderOrLPRiskManager) {
      return isExport ? "bankStatements" : "transactions";
    }

    if (isOperator) {
      return "transactions";
    }
  }

  if (isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.FUNDED, BID_REQUEST_STATUS_ENUM.EXECUTION])) {
    return "transactions";
  }

  if (isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.COMPLETED])) {
    if (isCustomer || isOperator) {
      return "documents";
    }

    if (isProviderOrLPRiskManager) {
      return "transactions";
    }
  }

  return showQuotes ? "quotes" : "documents";
};
